<template>
  <v-card class="elevation-0 mx-8 my-2 py-4 px-8">
    <v-row class="ma-0 pb-0">
        <v-card-title>
            Huecos
        </v-card-title>
        <v-spacer/>
        <v-text-field rounded outlined dense label="Cliente" v-model="client" clearable></v-text-field>
        <v-spacer/>
        <div>
            <v-tabs v-model="selectedYear">
                <v-tab v-for="year in yearOptions" :key="year">
                    {{ year }}
                </v-tab>
            </v-tabs>
        </div>
    </v-row>
    
    <v-data-table
        :sort-desc="true"
        sort-by="TotalAnual"
        height="calc(100vh - 300px)"
        fixed-header
        :loading="loading"
        :headers="headers"
        :items="data">
        <template v-for="header in headers.filter(h=>h.value!='name' && h.value!='TotalAnual')" v-slot:[`item.${header.value}`] = "{ item }">
            <div :key="header.value" style="text-align:center;">
                {{item[header.value].toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                <br/>
                <span v-if="item[header.value + '_kg']!=null" style="font-size:12px;">{{item[header.value + '_kg'].toLocaleString('es-MX') + ' kgs'}}</span>
            </div>
        </template>
        <template v-slot:[`item.name`] = "{ item }">
            <v-list-item class="px-0" style="min-height:0px!important; font-size:14px;" :to="{ path: '/clients/client/'+ item.id}">{{item.name}}</v-list-item>
        </template>
        <template v-slot:[`item.TotalAnual`] = "{ item }">
            <div style="text-align:center;">
                {{item.TotalAnual.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                <br/>
                <span style="white-space: nowrap; font-size:12px;">{{item.Total_kg.toLocaleString('es-MX') + ' kgs'}}</span>
            </div>
        </template>
    </v-data-table>

  </v-card>
</template>

<script>
import VueHorizontal from 'vue-horizontal';
import axios from "axios"
export default {
    components: {
        VueHorizontal
    },
    data(){
        return{
            selectedYear:undefined,
            first_load:true,
            ceros:true,
            client:null
        }
    },
    mounted() {
        this.fetchData()
        this.first_load = false
        localStorage.getItem('huecosYear')!=undefined?(this.selectedYear = localStorage.getItem('huecosYear')*1):this.selectedYear = this.yearOptions.length-1
        localStorage.getItem('huecosClient')!=undefined&&localStorage.getItem('huecosClient')!='null'?this.client=localStorage.getItem('huecosClient'):null
    },
    created(){
        localStorage.getItem('huecosYear')!=undefined?this.selectedYear=localStorage.getItem('huecosYear'):undefined
        localStorage.getItem('huecosClient')!=undefined&&localStorage.getItem('huecosClient')!='null'?this.client=localStorage.getItem('huecosClient'):null
    },
    watch:{
        selectedYear:{
            handler(){
                localStorage.setItem('huecosYear', this.selectedYear)
                this.fetchData()
            }, deep: true
        },
        client:{
            handler(){
                localStorage.setItem('huecosClient', this.client)
            }, deep:true
        }
    },
    computed:{
        yearOptions() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = 2022; year <= currentYear; year++) {
                years.push(year);
            }
            return years;
        },
        headers(){
            return this.$store.state.huecos.headers
        },
        loading(){
            return this.$store.state.huecos.loader
        },
        data(){
            const data = this.ceros ? this.$store.state.huecos.data : this.$store.state.huecos.data.filter(rd=>rd.TotalAnual > 0)
            return this.client!=null
            ? data.filter(d => d.name.toLowerCase().includes(this.client.toLowerCase())).map(rd => ({
                ...rd,
                TotalAnual: rd.TotalAnual,
            }))
            : data.map(rd => ({
                ...rd,
                TotalAnual: rd.TotalAnual,
            }))
        }
    },
    methods:{
        fetchData(){
            !this.first_load?this.$store.dispatch('huecos/getData', this.yearOptions[this.selectedYear]):undefined
        }
    },
}
</script>